export default __webpack_public_path__ + "static/media/pricingmodal.89128355.png";